import { Button } from '@material-ui/core'
import * as React from 'react'
import {
  Datagrid,
  List,
  Create,
  Edit,
  SimpleForm,
  TextField,
  TextInput,
  ReferenceArrayInput,
  NumberInput,
  ArrayInput,
  SimpleFormIterator,
  SelectArrayInput,
  Show,
  SimpleShowLayout,
  NumberField,
  ChipField,
  SingleFieldList,
  ReferenceArrayField,
  ArrayField,
  Filter,
  SelectInput,
  ReferenceInput,
  FormDataConsumer,
} from 'react-admin'
import { ArchivalToolbar } from '../components/ArchivalToolbar'
import {
  ArchivedSelect,
  CourseField,
  CourseIdSelect,
  CourseSelect,
  FullNameField,
  getFullName,
} from '../components/selects'
import { useCourseIds } from '../utils/useCourseIds'
import { useField } from 'react-final-form'
import cloneDeep from 'lodash/cloneDeep'

const ListBase = (props) => {
  const course_ids = useCourseIds()
  return (
    <List
      {...props}
      filters={<StudentGroupFilter />}
      sort={{ field: 'name', order: 'ASC' }}
      perPage={25}
      filter={course_ids ? { course_id: course_ids } : null}
    >
      <StudentGroupList {...props} />
    </List>
  )
}

const ShowBase = (props) => (
  <Show {...props}>
    <StudentGroupShow />
  </Show>
)

const CreateBase = (props) => (
  <Create {...props}>
    <StudentGroupForm />
  </Create>
)

const EditBase = (props) => (
  <Edit undoable={false} {...props}>
    <StudentGroupForm />
  </Edit>
)

export const list = ListBase
export const edit = EditBase
export const show = ShowBase
export const create = CreateBase

const StudentGroupFilter = (props) => (
  <Filter style={{ margin: 10 }} {...props}>
    <ArchivedSelect />
    <CourseIdSelect alwaysOn />
  </Filter>
)

const StudentGroupList = (props) => (
  <Datagrid
    rowClick={props.permissions?.includes('admin') ? 'edit' : 'show'}
    {...props}
  >
    <TextField label="Class Name" source="name" />
    <CourseField />
  </Datagrid>
)

const StudentGroupShow = (props) => (
  <SimpleShowLayout {...props}>
    <TextField fullWidth source="name" />

    <NumberField
      label="Maximum # of Students per Flight"
      source="max_cohort_size"
    />
    <CourseField />

    <ArrayField label="Assignment Groupings" source="assignment_groupings">
      <SingleFieldList>
        <ReferenceArrayField
          fullWidth
          allowEmpty={false}
          label="Assignments"
          source="assignment_ids"
          reference="assignments"
        >
          <SingleFieldList>
            <ChipField style={{ margin: '20px 10px 20px 0' }} source="name" />
          </SingleFieldList>
        </ReferenceArrayField>
      </SingleFieldList>
    </ArrayField>

    <ReferenceArrayField
      label="Students"
      source="student_ids"
      reference="students"
    >
      <SingleFieldList>
        <FullNameField style={{ marginRight: 12 }} />
      </SingleFieldList>
    </ReferenceArrayField>
  </SimpleShowLayout>
)

const StudentGroupForm = (props) => {
  return (
    <SimpleForm warnWhenUnsavedChanges toolbar={<ArchivalToolbar />} {...props}>
      <TextInput fullWidth label="Class Name" source="name" />

      <NumberInput
        fullWidth
        label="Maximum # of Students per Flight"
        source="max_cohort_size"
      />

      <CourseSelect />

      <ArrayInput label="Assignment Groupings" source="assignment_groupings">
        <SimpleFormIterator>
          <ReferenceArrayInput
            fullWidth
            allowEmpty={false}
            label="Assignments"
            perPage={100}
            source="assignment_ids"
            sort={{ field: 'name', order: 'ASC' }}
            reference="assignments"
          >
            <SelectArrayInput optionText="name" />
          </ReferenceArrayInput>
        </SimpleFormIterator>
      </ArrayInput>

      <StudentArrayInput />
    </SimpleForm>
  )
}

const StudentArrayInput = (props) => {
  const field = useField('student_ids')

  return (
    <ArrayInput
      fullWidth
      allowEmpty={false}
      label="Students"
      perPage={100}
      source="student_ids"
    >
      <SimpleFormIterator>
        <FormDataConsumer>
          {({ scopedFormData, getSource, id }) => {
            getSource('')
            const index = Number(id.match(/\d/)[0])
            const move = (dir) => {
              field.input.onChange(
                arraySwap(field.input.value, index, index + dir),
              )
            }
            return (
              <div style={{ display: 'flex' }}>
                <ReferenceInput
                  fullWidth
                  allowEmpty={false}
                  perPage={100}
                  label="Student"
                  reference="students"
                  source={getSource('')}
                  style={{ flex: 1, marginRight: 8 }}
                >
                  <SelectInput optionText={getFullName} />
                </ReferenceInput>
                <Button disabled={index === 0} onClick={() => move(-1)}>
                  Move Up
                </Button>
                <Button
                  disabled={index >= field.input.value.length - 1}
                  onClick={() => move(1)}
                >
                  Move Down
                </Button>
              </div>
            )
          }}
        </FormDataConsumer>
      </SimpleFormIterator>
    </ArrayInput>
  )
}

function arraySwap(arr, i1, i2) {
  var temp = arr[i1]
  arr[i1] = arr[i2]
  arr[i2] = temp
  return cloneDeep(arr)
}
